<template>
    <main class="flex flex-col min-h-0 h-full rounded-md shadow-lg bg-white overflow-hidden">
        <section class="flex justify-between border-b border-gray-200 bg-white">
            <slot name="header" />
        </section>
        <section class="loadable | flex-1 relative overflow-hidden" :class="{ 'loading': loading }">
            <div class="flex flex-col w-full h-full overflow-y-auto">
                <slot name="body" />
            </div>
        </section>
        <section class="flex justify-between border-t border-gray-200 bg-white">
            <slot name="footer" />
        </section>
    </main>
</template>

<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
